import React from 'react';
import { GoDotFill } from 'react-icons/go';
import FadeIn from '../common/FadeIn';

const marqueeItems = [
  "design with purpose",
  "strategy with heart",
  "design with purpose",
  "strategy with heart",
  "design with purpose",
  "strategy with heart",
  "design with purpose",
  "strategy with heart",
];

const ServiceMarqueeBar = () => {
  return (
    <FadeIn>
      <div className="w-full bg-[#2B2B2B] text-white py-4 overflow-hidden border-y border-[#3A3A3A]">
        <div className="flex w-full overflow-hidden">
          <div className="flex animate-marquee whitespace-nowrap items-center">
            {marqueeItems.concat(marqueeItems).map((text, idx) => (
              <div key={idx} className="flex items-center">
                <span className="font-interDisplayMedium text-[11px] sm:text-[12px] lowercase tracking-[0.18em] font-medium text-white/90">
                  {text}
                </span>
                <span className="text-[#ce884d] text-[10px] mx-8 sm:mx-12 inline-flex items-center justify-center">
                  <GoDotFill />
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </FadeIn>
  );
};

export default ServiceMarqueeBar;
